import { Signal } from "@suse-o11y/signal";
import { usePermanent } from "@suse-o11y/use-permanent";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { SmartHistoryQueue } from "./SmartHistoryQueue";
import { schema } from "./schema";

/**
 * Creates a SmartHistoryQueue.
 *
 * The queue is kept in-memory only so that each browser tab
 * maintains its own independent navigation history.
 * Enqueues the current location on every location change.
 *
 * @return a {@link Signal} containing the SmartHistoryQueue.
 */
export const useSmartHistoryQueue = (): Signal<SmartHistoryQueue> => {
	const location = useLocation();

	const queue = usePermanent(() => Signal(SmartHistoryQueue.decode(schema, "", { maxSize: 100 })));

	// write to the queue on location change
	useEffect(() => {
		queue.write((current) => current.enqueue(location));
	}, [queue, location]);

	return queue;
};
